{
  "sidebar": {
    "operators": "Оператори",
    "admins": "Администратори",
    "formBuilder": "Форме",
    "incidentSubmissions": "Инциденти",
    "submittedForms": "Послати Формулари",
    "signOut": "Одјави се",
    "profile": "Профил",
    "companies": "Привредни субјекти",
    "activityLogs": "Евиденција",
    "avoidedIncidents": "Избегнути инциденти"
  },
  "common": {
    "yes": "Да",
    "no": "Не",
    "filters": "Филтери",
    "apply": "Примени",
    "actions": "Акције",
    "select": "Изабери",
    "deletedUser": "Обрисан корисник",
    "deletedEntity": "Обрисано",
    "page": "Страна",
    "currentFile": "Тренутни фајл",
    "newFile": "Нови фајл",
    "uploadEmpty": "Кликните да отпремите",
    "uploadNewFile": "Отпремите нови фајл",
    "of": "од",
    "currency": "РСД",
    "hour": "сат",
    "switchTooltip": "Активност",
    "next": "Следеће",
    "previous": "Претходно",
    "submit": "Пошаљи",
    "back": "Назад",
    "locked": "Закључан",
    "unlocked": "Откључан",
    "on": "УКЉ",
    "off": "ИСКЉ",
    "noData": "Нема података",
    "noValue": "Нема вредности",
    "performingAction": "Извршавање акције...",
    "otherInputPlaceholder": "Унесите други текст...",
    "otherAnswerLabel": "Други одговор",
    "otherNumberPlaceholder": "Унесите број...",
    "otherNumericInputLabel": "Број корисника погођених инцидентом",
    "enums": {
      "incidentStatus": {
        "status": "Статус",
        "REPORTED": "Пријављен инцидент",
        "REPORT_SUBMITTED": "Достављено додатно обавештење",
        "ADDITIONAL_REPORT_SUBMITTED": "Достављен додатни извештај",
        "CLOSED": "Достављен завршни извештај",
        "DISMISSED": "Отклоњен"
      },
      "mediaType": {
        "UNKNOWN": "Непознато",
        "IMAGE": "Слика",
        "VIDEO": "Видео",
        "SVG": "СВГ",
        "AUDIO": "Аудио",
        "PDF": "ПДФ",
        "WORD": "Ворд документ",
        "ARCHIVE": "Архива"
      }
    },
    "errors": {
      "email": "Поље мора бити валидна емаил адреса",
      "minlength": "Поље мора имати најмање {{requiredLength}} карактера. Тренутна дужина је {{actualLength}}",
      "required": "Поље је обавезно",
      "maxlength": "Поље може имати највише {{requiredLength}} карактера. Тренутна дужина је {{actualLength}}",
      "pattern": "Поље мора одговарати шаблону {{requiredPattern}}",
      "min": "Поље мора бити најмање {{min}}",
      "max": "Поље може бити највише {{max}}",
      "websitePattern": "Молимо унесите валидан УРЛ сајта (нпр. https://example.com)",
      "durationPattern": "Молимо унесите валидно трајање у формату {{durationLabel}}",
      "mustMatchPassword": "Лозинке се не подударају",
      "strongPassword": "Лозинка мора бити најмање 8 карактера, садржавати најмање један велики број, један мали број и један посебан карактер",
      "pageNotFound": "Нема активних форми",
      "pageNotFoundDescription": "Нема активних форми. Молимо, покушајте поново касније или контактирајте подршку.",
      "startsWith": "Поље мора почињати са {{startsWith}} и садржати само цифре",
      "minDate": "Датум мора бити после {{minDate}}",
      "maxDate": "Датум мора бити пре {{maxDate}}",
      "step": "Поље мора бити умножак од {{step}}",
      "operatorIdMissing": "Обавезно је изабрати оператора пре попуњавања формулара"
    },
    "toast": {
      "success": "Успех",
      "warning": "Упозорење",
      "error": "Грешка"
    },
    "reportType": {
      "title": "Шта пријављујете?",
      "description": "Изаберите врсту пријаве да бисте отворили одговарајући формулар.",
      "incident": "Инцидент",
      "incidentDescription": "Инцидент који се догодио у ИКТ систему.",
      "avoided": "Избегнути инцидент",
      "avoidedDescription": "Инцидент који је спречен пре него што је наступио.",
      "change": "Промени врсту пријаве",
      "downloadPdf": "Преузми ПДФ образац"
    }
  },
  "confirmations": {
    "delete": "Обрисати ову ставку?",
    "submitForm": "Да ли сте сигурни да желите да пошаљете формулар?"
  },
  "buttons": {
    "no": "Откажи",
    "yes": "Потврди"
  },
  "fileDownload": {
    "downloading": "Започиње преузимање фајла"
  },
  "auth": {
    "forgotPassword": "Заборавили сте лозинку?",
    "login": "Пријавите се",
    "returnToLogin": "Вратите се на пријаву",
    "sendEmail": "Пошаљите емаил",
    "resetPassword": "Ресетујте лозинку",
    "register": "Региструјте се",
    "alreadyHaveAccount": "Већ имате налог?",
    "otpCode": "ОТП код",
    "otpExpiresIn": "Истиче за",
    "otpExpired": "ОТП код је истекао, молимо покушајте поново",
    "fields": {
      "name": "Име",
      "email": "Емаил",
      "password": "Лозинка",
      "repeatPassword": "Поновите лозинку"
    }
  },
  "submittedForms": {
    "all": {
      "title": "Сви Послати Формулари",
      "description": "Преглед и управљање свим послатим формуларима за инциденте"
    },
    "single": {
      "title": "Детаљи Послатог Формулара",
      "description": "Преглед детаљних информација о послатом формулару",
      "submittedBy": "Послао",
      "submittedAt": "Време слања",
      "id": "ИД",
      "noFields": "Нема поља за приказ",
      "noData": "Нема података",
      "noDataDescription": "Овај формулар не садржи податке за приказ"
    },
    "filter": {
      "search": "Претрага",
      "searchPlaceholder": "Претражите",
      "date": "Опсег Датума",
      "datePlaceholder": "Изаберите опсег датума"
    },
    "fields": {
      "id": "ИД",
      "uuid": "УУИД",
      "name": "Име",
      "status": "Статус",
      "submitted_at": "Послато"
    }
  },
  "languagePicker": {
    "en": "English",
    "sr": "Srpski (latinica)",
    "cyr": "Српски (ћирилица)"
  },
  "languages": {
    "en": "Енглески",
    "sr": "Српски (латиница)",
    "cyr": "Српски (ћирилица)"
  },
  "primeng": {
    "multiselect": {
      "selectedItemsLabel": "{0} ставке изабране"
    }
  }
}
